import React from 'react';
import styles from './LinkCell.module.css';

type LinkCellProps = {
  href: string;
  children: React.ReactNode;
};

export const LinkCell: React.FC<LinkCellProps> = ({ href, children }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
    >
      {children}
    </a>
  );
};
